<template>
  <AbaFiltro v-if="!loading" :titulo="titulo">
    <rnp-multiselect
      style="padding-bottom: 28px"
      v-model="objetoFiltro.unimeds"
      :propsMultiselect="{
        placeholder: 'Unimed',
        options: listaUnimeds,
        'track-by': 'id',
        label: 'textoExibicao'
      }"
    />
    <rnp-multiselect
      v-model="objetoFiltro.estados"
      :propsMultiselect="{
        placeholder: 'Estados',
        options: listaEstados,
        'track-by': 'chave',
        label: 'descricao'
      }"
    />
    <!-- <unicom-campo-calendario-v3
      class="competencia"
      fecharClique
      regrasValidacao="validacaoMes"
      :duploClique="false"
      v-model="objetoFiltro.competencia"
      placeHolder="Competência"
      mostrarIconeExcluir
      :componentesAtivos="['Meses', 'Anos']"
    /> -->
    <template slot="botao">
      <unicom-botao
        :desabilitado="!habilitado"
        @click="proximaAba"
        :largura="360"
        :altura="40"
      >
        CONTINUAR
      </unicom-botao>
    </template>
  </AbaFiltro>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaFiltroMixin from "../AbaFiltroMixin";

export default {
  mixins: [AbasMixin, AbaFiltroMixin],
  data() {
    return {
      listaUnimeds: [],
      listaEstados: []
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.sleep(500).finally(() => {
        this.inicializarUnimeds()
          .then(() => {
            this.inicializarEstados().finally(() => {
              this.loading = false;
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    inicializarUnimeds() {
      return this.getAllUnimeds().then(res => {
        this.listaUnimeds = res.data;
      });
    },
    inicializarEstados() {
      return this.getAllEnderecos().then(({ data }) => {
        this.listaEstados = data;
      });
    }
  }
};
</script>

<style scoped>
.competencia {
  margin: 1.5rem 0;
}
</style>
